import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import image from "../../images/metaimage.png"

export default () => (
  <StaticQuery
    query={graphql`
      query helmetQuery {
        site {
          siteMetadata {
            title
            author
            description
            keywords
            url
          }
        }
      }
    `}
    render={data => (
      <Helmet>
        <title content={data.site.siteMetadata.title} />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap"
          rel="stylesheet"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
        />
        <meta name="description" content={data.site.siteMetadata.description} />
        <meta
          property="og:description"
          content={data.site.siteMetadata.description}
        />
        <meta name="keywords" content={data.site.siteMetadata.keywords} />
        <title>{data.site.siteMetadata.title}</title>
        <meta property="og:title" content={data.site.siteMetadata.title} />
        <html lang="en" />
        {/* Google / Search Engine Meta Tags */}
        <meta itemProp="name" content={data.site.siteMetadata.author} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content="1200"/>
        <meta property="og:url" content={data.site.siteMetadata.url} />
      </Helmet>
    )}
  />
)
